import {
  createFileRoute,
  Outlet,
  redirect,
  useMatches,
} from '@tanstack/react-router'
import config from '@/config/config.env'
import NavBar from '@/pages/auth/navbar'

export const Route = createFileRoute('/_auth')({
  beforeLoad: () => {
    const isMaintenanceMode = config.appSettings.isMaintenance === 'true'
    if (isMaintenanceMode) {
      throw redirect({
        to: '/503',
      })
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const matches = useMatches()
  const isSpecialRoute = matches.some((match) =>
    ['/_auth/auth/talent-scout/', '/_auth/auth/callback/'].includes(
      match.routeId
    )
  )
  return (
    <div>
      {!isSpecialRoute && <NavBar />}
      <Outlet />
    </div>
  )
}
